import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { Icons, Images } from "assets";
import React, { useEffect, useState } from "react";
import styles from "./style.module.scss";
import { getGenresService } from "shared/services/general";
import { Grid, Skeleton } from "@mui/material";
import AutoComplete from "shared/components/projectHeadComponents/controlCenter/autoCompleteGenres";
import DoneIcon from "@mui/icons-material/Done";
import classNames from "classnames";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface GenreLandingPageProps {
  open: any;
  handleClose: () => void;
}

const dummy = [
  { id: 1, bookName: "Book Name 1" },
  { id: 2, bookName: "Book Name 2" },
  { id: 3, bookName: "Book Name 3" },
  { id: 4, bookName: "Book Name 4" },
  { id: 6, bookName: "Book Name 6" },
  { id: 7, bookName: "Book Name 7" },
  { id: 8, bookName: "Book Name 8" },
  { id: 9, bookName: "Book Name 9" },
  { id: 10, bookName: "Book Name 10" },
];

export default function GenreLandingPage({
  open,
  handleClose,
}: GenreLandingPageProps) {
  const [search, setSearch] = useState<string>("");
  const [selectedGenre, setSelectedGenre] = useState<any>(null);
  const [allGenres, setAllGenres] = useState<any>([]);
  const [loader, setLoader] = useState<boolean>(true);
  const [books, setBooks] = useState<any>(dummy);
  const [selectedBooks, setSelectedBooks] = useState<any>([]);
  const [bookLoader, setBookLoader] = useState<boolean>(false);

  useEffect(() => {
    if (selectedGenre) {
      setBookLoader(true);
      setTimeout(() => {
        setBookLoader(false);
      }, 2000);
    }

    //eslint-disable-next-line
  }, [selectedGenre]);

  const getAllGenres = () => {
    setLoader(true);
    getGenresService()
      .then(({ data: { data } }) => {
        setLoader(false);
        setAllGenres(data);
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  useEffect(() => {
    if (open) {
      getAllGenres();
    }
  }, [open]);

  const onClose = () => {
    handleClose();
    setSelectedGenre(null);
    setSelectedBooks([]);
  };

  const handleSelectBook = (item: any) => {
    let temp: any = [...selectedBooks];
    let index = temp.findIndex((i: any) => i.id === item?.id);

    if (index > -1) {
      temp.splice(index, 1);
    } else {
      temp.push(item);
    }
    setSelectedBooks(temp);
  };

  const handleDelete = (item: any) => {
    let temp: any = [...selectedBooks];
    setSelectedBooks(temp.filter((i: any) => i.id !== item?.id));
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            width: "100%",
            justifyContent: "center",
            maxWidth: (theme) => theme.spacing(110),
            borderRadius: "10px",
          },
          className: styles.paperProps,
        }}
      >
        <DialogContent sx={{ padding: "0px" }}>
          <div className={styles.contentContainer}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div className={styles.heading}>Add New Genre on Homepage</div>
              <div>
                <Icons.CrossIcon
                  onClick={() => onClose()}
                  className={styles.crossIcon}
                />
              </div>
            </div>
            <div>
              <label className={styles.label}>Select Genre</label>
              {loader ? (
                <Skeleton
                  variant="rounded"
                  width={"100%"}
                  height={50}
                  sx={{ borderRadius: "32px" }}
                />
              ) : (
                <AutoComplete
                  list={allGenres}
                  setSearchText={setSearch}
                  searchText={search}
                  selectedItem={selectedGenre}
                  setSelectedItem={(option: any) => {
                    setSelectedGenre(option);
                    if (!option) {
                      setSelectedBooks([]);
                    }
                  }}
                />
              )}
            </div>

            <Grid container>
              <Grid item xs={8.5} sx={{ borderRight: "1px solid #e2e2e5" }}>
                {bookLoader ? (
                  <Loader />
                ) : selectedGenre ? (
                  <>
                    <div>
                      <label className={styles.label}>Select Book</label>
                    </div>

                    <div className={styles.booksMainContainer}>
                      {books?.map((item: any) => {
                        let selected = selectedBooks?.some(
                          (itm: any) => itm?.id === item?.id
                        );
                        return (
                          <div
                            className={styles.singleBookContainer}
                            onClick={() => handleSelectBook(item)}
                          >
                            <div className={styles.booksInfo}>
                              <img
                                src={Images.DefaultBookImg}
                                alt="profile_picture"
                                className={styles.bookImg}
                              />
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "2px",
                                }}
                              >
                                <label className={styles.bookName}>
                                  Book Name
                                </label>

                                <label className={styles.authorName}>
                                  by <span>Author Name</span>
                                </label>
                              </div>
                            </div>

                            <div
                              className={classNames(
                                styles.checkbox,
                                selected && styles.checked
                              )}
                            >
                              {selected && (
                                <DoneIcon
                                  sx={{
                                    color: "white",
                                    height: "12px",
                                    width: "12px",
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    {!books?.length && (
                      <div className={styles.noDataContainer}>
                        <Icons.NoDataIcon />
                        <label className={styles.label}>No Book Found</label>
                      </div>
                    )}
                  </>
                ) : (
                  <label className={styles.label}>
                    Please Select Genre to continue.
                  </label>
                )}
              </Grid>
              <Grid item xs={3.5} sx={{ paddingLeft: "12px" }}>
                <div className={styles.selectedBooksContainer}>
                  <div>
                    <label className={styles.label}>Selected Book</label>
                  </div>

                  <div className={styles.thumbnailsContainer}>
                    {selectedBooks?.map((item: any) => {
                      return (
                        <div className={styles.singleThumbnail}>
                          <img
                            src={Images.DefaultBookImg}
                            alt="book-cover"
                            className={styles.bookThumbnail}
                          />
                          <Icons.DeleteIcon
                            className={styles.deleteIcon}
                            onClick={() => handleDelete(item)}
                          />
                        </div>
                      );
                    })}
                  </div>

                  {!selectedBooks?.length && (
                    <div
                      className={styles.noDataContainer}
                      style={{ marginTop: "20px" }}
                    >
                      <Icons.NoDataIcon
                        style={{ height: "120px", width: "120px" }}
                      />
                      <label className={styles.label}>No Books Selected</label>
                    </div>
                  )}

                  <div
                    style={{
                      position: "absolute",
                      bottom: "0px",
                      right: "0px",
                    }}
                  >
                    <button className={styles.btn}>Add</button>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}

const Loader = () => {
  return (
    <div className={styles.booksMainContainer}>
      {Array.from({ length: 8 }).map((item, index) => {
        return (
          <div className={styles.loaderContainer}>
            <div style={{ display: "flex", gap: "4px" }}>
              <Skeleton variant="rounded" width={40} height={40} />
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Skeleton variant="rectangular" width={120} height={20} />
                <Skeleton variant="rectangular" width={120} height={10} />
              </div>
            </div>
            <div>
              <Skeleton variant="rectangular" width={20} height={20} />
            </div>
          </div>
        );
      })}
    </div>
  );
};
